import { useState, useEffect } from 'react';
import { Bell, X } from 'lucide-react';
import { useFirebase } from '@/hooks/use-firebase';

export default function NotificationPermissionBanner() {
  const { permissionStatus, requestPermission, isTokenRegistered } = useFirebase();
  const [dismissed, setDismissed] = useState(false);
  const [isRequesting, setIsRequesting] = useState(false);

  // Don't show if already granted or denied, or if dismissed
  const shouldShow = permissionStatus === 'default' && !dismissed;

  // Also check localStorage to persist dismissal
  useEffect(() => {
    const wasDismissed = localStorage.getItem('notification-banner-dismissed');
    if (wasDismissed === 'true') {
      setDismissed(true);
    }
  }, []);

  const handleEnable = async () => {
    setIsRequesting(true);
    await requestPermission();
    setIsRequesting(false);
  };

  const handleDismiss = () => {
    setDismissed(true);
    localStorage.setItem('notification-banner-dismissed', 'true');
  };

  if (!shouldShow) return null;

  return (
    <div className="bg-orange-50 border-b border-orange-200 px-4 py-3">
      <div className="flex items-center justify-between max-w-7xl mx-auto">
        <div className="flex items-center gap-3">
          <div className="p-2 bg-orange-100 rounded-full">
            <Bell className="w-5 h-5 text-orange-600" />
          </div>
          <div>
            <p className="text-sm font-medium text-orange-800">
              Enable notifications to receive call alerts
            </p>
            <p className="text-xs text-orange-600">
              Get notified instantly when users want to connect with you
            </p>
          </div>
        </div>
        
        <div className="flex items-center gap-2">
          <button
            onClick={handleEnable}
            disabled={isRequesting}
            className="px-4 py-1.5 bg-orange-500 hover:bg-orange-600 disabled:bg-orange-300 text-white text-sm font-medium rounded-lg transition-colors"
          >
            {isRequesting ? 'Enabling...' : 'Enable'}
          </button>
          <button
            onClick={handleDismiss}
            className="p-1.5 text-orange-400 hover:text-orange-600 transition-colors"
            title="Dismiss"
          >
            <X className="w-5 h-5" />
          </button>
        </div>
      </div>
    </div>
  );
}
